// ReactJS
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { formatNumber, routes } from '../../constants.js/misc';
import AddProductIcon from '../../assets/icons/home/add-icon.svg';
import ShareIcon from '../../assets/icons/home/share-icon.svg';
import EditIcon from '../../assets/icons/home/edit-icon.svg';
import ClientIcon from '../../assets/icons/home/add-client-icon.svg';
import { Grid, Typography } from '@material-ui/core';
import { ArrowForward } from '@material-ui/icons';
import FrillWidget from '../../components/Widget/Widget';
import { getStoreUsageService } from '../../services/billing';
import { getProcess } from '../../services/home';
import {
    ContentSubTitle,
    Content,
    HomePageCardContainer,
    HomePageProductViewsContainer,
    HomePageMobileCardContainer,
    HomePageMobileCardIcon,
    HomePageMobileOrderButton,
    HomePageDaysContainer,
    HomePageDayAchiveContainer,
} from './HomePage.styles';
import { colors } from '../../constants.js/colors';
import { functionalOrderIcon as OrderIcon } from '../../assets/icons/home/functional-order-icon';
import { getDailyMetricsByDateService, getWeeklyInsightsService } from '../../services/store';
import { valueMappingSalesInsights } from './constants';
import { AddClientModal } from './components/AddClientModal';

export const HomePage = ({ storeId, storeData }) => {
    const { t } = useTranslation();

    const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
    const [infoStore, setInfoStore] = useState('');
    const [progress, setProgress] = useState(0);
    const [statusPlan, setStatusplan] = useState(null);
    const [daysToPay, setDaysToPay] = useState(null);
    const [paymentStatus, setPaymentStatus] = useState(null);
    const [isPreviewLinkOpen, setIsPreviewLinkOpen] = useState(false);
    const [isClientModalOpen, setIsClientModalOpen] = useState(false);
    const [salesInsightsData, setSalesInsightsData] = useState(valueMappingSalesInsights);
    const [dailyMetricsData, setDailyMetricsData] = useState({
        total_sales: 0,
        total_orders: 0,
    });

    const openPreviewLink = () => {
        setIsPreviewLinkOpen(true);
    };

    const getConsecutiveSales = () => {
        const consecutiveSales = [];
        for (let i = 1; i < salesInsightsData.length; i++) {
            if (salesInsightsData[i - 1].value && salesInsightsData[i].value) {
                consecutiveSales.push([salesInsightsData[i - 1], salesInsightsData[i]]);
            }
        }
        return consecutiveSales.length;
    };

    const handleAddClient = () => {
        setIsClientModalOpen(true);
    };

    useEffect(() => {
        if (!infoStore) {
            getStoreUsageService(storeId, 'CO')
                .then(({ data }) => {
                    setInfoStore(data);
                })
                .catch((err) => {});
        }
    }, [storeData, infoStore]);

    useEffect(() => {
        if (storeData) {
            if (storeData.store_plan) {
                setStatusplan(storeData.store_plan.store_plan_status_id);
                setDaysToPay(storeData.store_plan.days_to_pay);
                setPaymentStatus(storeData.store_plan.store_plan_payment_status_id);
            }
        }
    }, [storeData]);

    useEffect(() => {
        if (!progress && storeId) {
            getProcess(storeId)
                .then(({ data }) => setProgress(data.progress))
                .catch((err) => {});
        }
    }, [progress, storeData, storeId]);

    useEffect(() => {
        if (storeId) {
            getWeeklyInsightsService(storeId)
                .then(({ data }) => {
                    const days = ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Do'];
                    const valueMapping = Object.entries(data).map(([key, value], index) => ({
                        label: days[index],
                        value: value,
                        originalLabel: key,
                    }));
                    setSalesInsightsData(valueMapping);
                })
                .catch((err) => {});
        }
    }, [storeId]);

    useEffect(() => {
        if (storeId) {
            getDailyMetricsByDateService(storeId)
                .then(({ data }) => {
                    setDailyMetricsData(data);
                })
                .catch((err) => {});
        }
    }, [storeId]);

    return (
        <Content isActive={storeData ? (storeData.active ? false : true) : false}>
            <Grid container xs={12} spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h3" style={{ fontWeight: 'bold' }}>
                        {t('HomePage.title', { name: storeData.name })}
                    </Typography>
                    <ContentSubTitle>
                        <Typography variant="body2">{t('HomePage.subtitle')}</Typography>
                    </ContentSubTitle>
                </Grid>

                <Grid item xs={12} md={4}>
                    <HomePageCardContainer
                        style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}
                    >
                        <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                            Ventas del día
                        </Typography>
                        <Typography variant="h2" style={{ fontWeight: 700 }}>
                            {formatNumber(dailyMetricsData.total_sales, 'COP')}
                        </Typography>
                    </HomePageCardContainer>
                </Grid>
                <Grid item xs={12} md={4}>
                    <HomePageCardContainer
                        style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}
                    >
                        <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                            Pedidos del día
                        </Typography>
                        <Typography variant="h2" style={{ fontWeight: 700 }}>
                            {dailyMetricsData.total_orders}
                        </Typography>
                    </HomePageCardContainer>
                </Grid>
                <Grid item xs={12} md={4}>
                    <HomePageCardContainer
                        style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}
                    >
                        <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                            Meta semanal
                        </Typography>
                        <Typography variant="h2" style={{ fontWeight: 700 }}>
                            Coming soon
                        </Typography>
                    </HomePageCardContainer>
                </Grid>

                <Grid item xs={12} md={8} spacing={2}>
                    <HomePageCardContainer
                        style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <div>
                                <Typography variant="h5">
                                    Los que responden rápido venden más
                                </Typography>
                                <Typography variant="subtitle1">
                                    Informa el estado del pedido y gana clientes que vuelven
                                </Typography>
                            </div>
                            <div style={{ width: '100%', maxWidth: '160px', maxHeight: '48px' }}>
                                <Link
                                    to={routes.ordersPage}
                                    style={{
                                        textDecoration: 'none',
                                        color: 'inherit',
                                        fontSize: '18px',
                                    }}
                                >
                                    <HomePageMobileOrderButton fullWidth startIcon={<OrderIcon />}>
                                        Ver Pedidos
                                    </HomePageMobileOrderButton>
                                </Link>
                            </div>
                        </div>

                        <Typography variant="subtitle1">Acciones rápidas</Typography>

                        <div style={{ display: 'flex', gap: '16px' }}>
                            <Link
                                to={routes.createOrder}
                                style={{
                                    textDecoration: 'none',
                                    color: 'inherit',
                                    display: 'flex',
                                    flex: 1,
                                }}
                            >
                                <HomePageMobileCardContainer
                                    style={{
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: '8px',
                                        padding: '8px',
                                        backgroundColor: colors.lightGray,
                                        textAlign: 'center',
                                    }}
                                >
                                    <HomePageMobileCardIcon>
                                        <img src={AddProductIcon} />
                                    </HomePageMobileCardIcon>
                                    <Typography variant="body2">{t('Order.create')}</Typography>
                                </HomePageMobileCardContainer>
                            </Link>
                            <button
                                onClick={() => handleAddClient()}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    outline: 'none',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    flex: 1,
                                }}
                            >
                                <HomePageMobileCardContainer
                                    style={{
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: '8px',
                                        padding: '8px',
                                        backgroundColor: colors.lightGray,
                                        textAlign: 'center',
                                    }}
                                >
                                    <HomePageMobileCardIcon>
                                        <img src={ClientIcon} />
                                    </HomePageMobileCardIcon>
                                    <Typography variant="body2">
                                        {t('ClientPage.addClient')}
                                    </Typography>
                                </HomePageMobileCardContainer>
                            </button>
                            <button
                                onClick={openPreviewLink}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    outline: 'none',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    flex: 1,
                                }}
                            >
                                <HomePageMobileCardContainer
                                    style={{
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: '8px',
                                        padding: '8px',
                                        backgroundColor: colors.lightGray,
                                        textAlign: 'center',
                                    }}
                                >
                                    <HomePageMobileCardIcon>
                                        <img src={ShareIcon} />
                                    </HomePageMobileCardIcon>
                                    <Typography variant="body2">
                                        {t('MobileHomepage.share')}
                                    </Typography>
                                </HomePageMobileCardContainer>
                            </button>
                            <Link
                                to={routes.store}
                                style={{
                                    textDecoration: 'none',
                                    color: 'inherit',
                                    display: 'flex',
                                    flex: 1,
                                }}
                            >
                                <HomePageMobileCardContainer
                                    style={{
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: '8px',
                                        padding: '8px',
                                        backgroundColor: colors.lightGray,
                                        textAlign: 'center',
                                    }}
                                >
                                    <HomePageMobileCardIcon>
                                        <img src={EditIcon} />
                                    </HomePageMobileCardIcon>
                                    <Typography variant="body2">
                                        {t('HomePage.customBtn')}
                                    </Typography>
                                </HomePageMobileCardContainer>
                            </Link>
                        </div>
                    </HomePageCardContainer>
                </Grid>

                <Grid item xs={12} md={4}>
                    <HomePageCardContainer
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '16px',
                            overflowX: 'scroll',
                        }}
                    >
                        <Typography variant="h5">Racha de ventas</Typography>
                        <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                            {salesInsightsData.map((sale, index) => (
                                <HomePageDaysContainer key={index}>
                                    <HomePageDayAchiveContainer
                                        style={{
                                            backgroundColor: sale.value && colors.primary.main,
                                            fontWeight: sale.value ? 'bold' : 'normal',
                                        }}
                                    >
                                        {sale.value ? '✓' : sale.label}
                                    </HomePageDayAchiveContainer>
                                    {sale.label}
                                </HomePageDaysContainer>
                            ))}
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <Typography variant="subtitle1">
                                {getConsecutiveSales()} días consecutivos
                            </Typography>
                        </div>
                    </HomePageCardContainer>
                </Grid>
            </Grid>

            <Grid container xs={12} spacing={3}>
                <Grid item xs={12}>
                    <HomePageProductViewsContainer>
                        <Typography variant="h5" style={{ fontWeight: 'semi-bold' }}>
                            Productos más vistos
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            style={{ display: 'flex', alignItems: 'center' }}
                        >
                            Ver todos <ArrowForward fontSize="small" />
                        </Typography>
                    </HomePageProductViewsContainer>
                </Grid>
                <Grid item xs={12} md={3}>
                    <HomePageCardContainer>Coming soon</HomePageCardContainer>
                </Grid>
                <Grid item xs={12} md={3}>
                    <HomePageCardContainer>Coming soon</HomePageCardContainer>
                </Grid>
                <Grid item xs={12} md={3}>
                    <HomePageCardContainer>Coming soon</HomePageCardContainer>
                </Grid>
                <Grid item xs={12} md={3}>
                    <HomePageCardContainer>Coming soon</HomePageCardContainer>
                </Grid>
            </Grid>

            <Grid container xs={12} spacing={3}>
                <Grid item xs={12}>
                    <div
                        style={{
                            background: '#73EDB833',
                            padding: '25px',
                            border: '1px solid #73EDB833',
                            borderRadius: '12px',
                        }}
                    >
                        <Typography variant="subtitle1">
                            Recuerda: no tienes que hacerlo todo hoy. Pero si vendes un poco cada
                            día, tu tienda crece sola.
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            style={{ color: colors.primary.dark, fontWeight: 500 }}
                        >
                            — El equipo de Ecometri 💚
                        </Typography>
                    </div>
                </Grid>
            </Grid>
            <FrillWidget />
            <AddClientModal
                storeId={storeId}
                userStoreId={storeData?.default_user_store?.id}
                isModalOpen={isClientModalOpen}
                setIsModalOpen={setIsClientModalOpen}
            />
        </Content>
    );
};
const mapStateToProps = ({ auth, common }) => ({
    storeId: auth.storeId,
    storeData: common.storeData,
});

export default connect(mapStateToProps)(HomePage);
